// https://codepen.io/ncerminara/pen/eKNROb
import { Query } from '@apollo/client/react/components';
import useMediaQuery from '@mui/material/useMediaQuery';
import dynamic from 'next/dynamic';
import React, { useEffect, useState } from 'react';
import { IS_NEWSLETTER_SUBSCRIBED } from '../../helpers/graphql/newsletter';
import { getUser } from '../../helpers/token';
import PostGrid from '../Grid/PostGrid';
import LoggedOutFeed from './LoggedOutFeed';

const JoinCard = dynamic(() => import('../Community/JoinCard'), {
  ssr: false,
});
const StickyBox = dynamic(() => import('react-sticky-box'), {
  ssr: false,
});
const NavSide = dynamic(() => import('../Sidebar/NavSide'), {
  ssr: false,
});
const NewsLetterSubscribe = dynamic(
  () => import('../Sidebar/NewsLetterSubscribe'),
  {
    ssr: false,
  },
);
const BlogGridList = dynamic(() => import('../Sidebar/BlogGridList'), {
  ssr: false,
});
const DiscoverCountry = dynamic(() => import('../Sidebar/DiscoverCountry'), {
  ssr: false,
});
const NewUsers = dynamic(() => import('../Sidebar/NewUsers'), {
  ssr: false,
});
const SocialLinks = dynamic(() => import('../Sidebar/SocialLinks'), {
  ssr: false,
});
const LegalNotice = dynamic(() => import('../Sidebar/LegalNotice'), {
  ssr: false,
});

const Feed = props => {
  const renderLeftSidebar = useMediaQuery('(min-width: 768px)');
  const renderRightSidebar = useMediaQuery('(min-width: 1200px)');

  const {
    active,
    orderby,
    minScore,
    feed,
    isFeed,
    following,
    isJoinCard,
    WritePostCard,
  } = props;

  const [user, setUser] = useState(null);

  useEffect(() => {
    setUser(getUser() || false);
  }, []);

  const grid = { lg: 12, md: 12, sm: 12, xs: 12 };

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-xl-3 col-lg-4 col-md-4 d-none d-xl-block d-lg-block d-md-block">
            {renderLeftSidebar ? (
              <StickyBox offsetTop={65} offsetBottom={10}>
                <NavSide active={active} />
                {(user && (
                  <Query query={IS_NEWSLETTER_SUBSCRIBED}>
                    {({ data }) => {
                      if (data && data.isNewsletterSubscribed === false)
                        return (
                          <div className="mt-2">
                            <NewsLetterSubscribe />
                          </div>
                        );
                      return <></>;
                    }}
                  </Query>
                )) ||
                  (user === false && (
                    <div className="mt-2">
                      <NewsLetterSubscribe />
                    </div>
                  ))}
              </StickyBox>
            ) : (
              <></>
            )}
          </div>
          <div className="col-xl-6 col-lg-8 col-md-8 col-sm-12 p-0">
            {WritePostCard ? <WritePostCard /> : <></>}
            {isJoinCard ? (
              <div className="mt-3">
                <JoinCard text="follow your favorite travel bloggers" />
              </div>
            ) : (
              // disable SSR for feed -> needs client-side cookie
              (!isFeed || (isFeed && feed)) && (
                <PostGrid
                  active={active}
                  query={{
                    onlyVideo: active === 'videos',
                    orderby,
                    limit: 10,
                    minScore,
                    language: 'en',
                    following,
                  }}
                  grid={grid}
                  cardHeight={330}
                  poststyle="grid"
                />
              )
            )}
            {isFeed && feed === false && <LoggedOutFeed grid={grid} />}
          </div>
          <div className="col-xl-3 d-xl-block d-none">
            {renderRightSidebar ? (
              <StickyBox offsetTop={65} offsetBottom={10}>
                <div className="pt-2" />
                <DiscoverCountry />
                <div className="pt-2" />
                <BlogGridList />
                <div className="pt-2" />
                {user && (
                  <>
                    <NewUsers />
                    <div className="pt-2" />
                  </>
                )}
                <SocialLinks />
                <LegalNotice />
              </StickyBox>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Feed;
